import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import VirtualAccountsSetupStepper from './VirtualAccountsSetupStepper';

const VirtualAccountSetupsPicker = () => {
  const { resource } = useMetaLayoutContext();

  if (resource.attr('facetPlanVirtualAccountSetups')) {
    return (
      <VirtualAccountsSetupStepper />
    );
  }

  return null;
};

export default VirtualAccountSetupsPicker;
